import type {TheoryResources} from './learning-theory';

// Audio belongs to this issued body only. Adjacent/current revisions cannot
// supply a replacement for historical issued content.
export function authoredResources(content:any, resources:TheoryResources={}):TheoryResources {
 return {...resources,audio:Object.fromEntries((content?.audioReferences??[]).map((ref:any)=>[ref.key,ref.audio]))};
}
